import { IStatusState, IStatusAction, ADD_PENDING, COMPLETE_PENDING, IPendingItem } from "./types";

const initialState: IStatusState = {
  isPending: false,
  items: [],
};

const addPending = (state: IStatusState, item: IPendingItem) => {
  const items = state.items.map(i => ({
    id: i.id,
    description: i.description,
  }));

  items.push(item);

  return {
    isPending: true,
    items: items,
    description: items.length > 0 ? items[0].description : undefined,
  };
};

const removePending = (state: IStatusState, item: IPendingItem) => {
  const items = state.items
    .filter(i => {
      return i.id !== item.id;
    })
    .map(i => ({
      id: i.id,
      description: i.description,
    }));

  return {
    isPending: items.length > 0,
    items: items,
    description: items.length > 0 ? items[0].description : undefined,
  };
};

export function statusReducer(state: IStatusState = initialState, action: IStatusAction): IStatusState {
  switch (action.type) {
    case ADD_PENDING:
      return addPending(state, action.item);
      break;
    case COMPLETE_PENDING:
      return removePending(state, action.item);
      break;
  }
  return state;
}
